module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAAK1JREFUGBljZACCyUf+S/1jYOj/z/DfBcRnZGDcw8TAUJhrw/iMse/Yf2nmfwyXjCR+8aoK/mIFKbj9nu33uRdsn/8yMeixMP1n6AdJ6ov9BEuCFEDZvGdfsvUzMf7776IqBNEJkoQBkGkgOaBVOAAjRJzpPxPjntvv2H6jKwOJgeSY/jEyFAId9OXiK/bf3/4wMoAwiA0SA8mBDQL5BORYkJ0gk0A6QZJFVoxPAZiRSt1De5ZRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/sprite-icons/marker-pin-unvailable-filtered.png
// module id = 1191
// module chunks = 0